import { createReducer, on } from "@ngrx/store";
import * as ownerActions from "./owner.actions";
import * as _ from "lodash";
import { OwnerModel } from "../../../../../petszel-shared/src/lib/shared-models/owner.model";

export interface OwnerStateModel {
  initialState: boolean,
  success: boolean,
  errorCode: string,
  errorMessage: string
  owner: OwnerModel
}

export const ownerInitialState: OwnerStateModel = {
  initialState: true,
  success: true,
  errorCode: '',
  errorMessage: '',
  owner: Object.create(null) as OwnerModel,
};

export const ownerReducer = createReducer(
  ownerInitialState,
  on(ownerActions.loadOwner, (state) => state),
  on(ownerActions.getOwner, (state, { owner }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: true,
    errorCode: '',
    errorMessage: '',
    owner
  })),
  on(ownerActions.getOwnerError, (state, { errorCode, errorMessage }) => ({
    ..._.cloneDeep(state),
    initialState: false,
    success: false,
    errorCode,
    errorMessage
  })),
  on(ownerActions.setOwner, (state, { owner }) =>({
    ..._.cloneDeep(state),
    owner
  })),
  on(ownerActions.resetOwner, () => ({
    ..._.cloneDeep(ownerInitialState),
  }))
);
